const CONFIG = {
  KEY: 'YOUR_API_KEY',
  BASE_URL: 'https://restaurant-api.dicoding.dev/',
  BASE_LARGEIMAGE_URL: 'https://restaurant-api.dicoding.dev/images/medium/',
  BASE_SMALLIMAGE_URL: 'https://restaurant-api.dicoding.dev/images/small/',
  DEFAULT_LANGUAGE: 'en-us',
  CACHE_NAME: new Date().toISOString(),
  DATABASE_NAME: 'hungerapp-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'resto',
};

export default CONFIG;
